module.exports = __webpack_public_path__ + "static/media/hcl_new_small.7226a3d0.png";